import { render, staticRenderFns } from "./bulletin.vue?vue&type=template&id=f188a3f6&scoped=true&"
import script from "./bulletin.vue?vue&type=script&lang=js&"
export * from "./bulletin.vue?vue&type=script&lang=js&"
import style0 from "./bulletin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bulletin.vue?vue&type=style&index=1&id=f188a3f6&lang=less&scoped=true&"
import style2 from "./bulletin.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f188a3f6",
  null
  
)

export default component.exports